/* eslint-disable id-length */
/**
 * This function calculates the relative luminance of the provided color according to
 * the WCAG 2.0 specification and returns either black or white text color depending
 * on the background brightness.
 *
 * @param hexColor - The background color in hexadecimal format (with or without leading '#')
 * @returns A hexadecimal color string ('#000000' for black or '#FFFFFF' for white) that
 *          provides optimal contrast against the specified background color
 *
 * @see https://www.w3.org/TR/WCAG20/#relativeluminancedef
 */
export default (hexColor: string): string => {
  const color = hexColor.charAt(0) === "#" ? hexColor.substring(1) : hexColor;

  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5 ? "#000000" : "#FFFFFF";
};
